export const BASE_URL = process.env.REACT_APP_BASE_URL
export const BOOK_PROCESSOR_BASE_URL =
  process.env.REACT_APP_BOOK_PROCESSOR_BASE_URL
export const S3_BUCKET_NAME = process.env.REACT_APP_S3_BUCKET_NAME
export const STRIPE_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
export const STRIPE_SETUP_INTENT_REDIRECT_URL =
  process.env.REACT_APP_STRIPE_SETUP_INTENT_REDIRECT_URL
